import { CheckCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export function AdvertiseThankYou({ heading, subtitle, children, testId, secondaryLinks = [] }) {
  return (
    <div className="flex min-h-[70vh] items-center justify-center px-4 py-16">
      <div className="max-w-lg text-center">
        <div className="mx-auto mb-6 grid h-20 w-20 place-items-center rounded-full bg-green-50">
          <CheckCircle size={40} className="text-green-600" />
        </div>
        <h1 className="font-display text-3xl font-bold text-slate-900" data-testid={testId}>{heading}</h1>
        <p className="mt-2 text-slate-600">{subtitle}</p>
        {children}
        {secondaryLinks.length > 0 && (
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            {secondaryLinks.map((l) => (
              <Button key={l.to} asChild variant={l.variant || 'outline'} className="rounded-full">
                <Link to={l.to}>{l.label}</Link>
              </Button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
